var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.647 10.75V17.249C10.6808 17.5845 10.8353 17.8963 11.0818 18.1265C11.3283 18.3566 11.65 18.4893 11.987 18.5C12.3299 18.5103 12.6628 18.3847 12.9134 18.1505C13.1641 17.9164 13.312 17.5927 13.325 17.25V10.75C13.2911 10.415 13.1368 10.1037 12.8907 9.8738C12.6447 9.64393 12.3236 9.51111 11.987 9.5C11.6439 9.48919 11.3104 9.61456 11.0593 9.84875C10.8083 10.0829 10.6601 10.4069 10.647 10.75Z",
    fill: "var(--icon-primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9394 5.43934C10.6581 5.72064 10.5 6.10218 10.5 6.5C10.4917 6.69921 10.5248 6.89798 10.5972 7.08374C10.6697 7.26951 10.7799 7.43822 10.9208 7.5792C11.0618 7.72019 11.2305 7.83038 11.4163 7.90281C11.6021 7.97524 11.8008 8.00834 12 8C12.1992 8.00834 12.398 7.97524 12.5838 7.90281C12.7695 7.83038 12.9383 7.72019 13.0792 7.5792C13.2202 7.43822 13.3304 7.26951 13.4029 7.08374C13.4753 6.89798 13.5084 6.69921 13.5 6.5C13.5 6.10218 13.342 5.72064 13.0607 5.43934C12.7794 5.15804 12.3979 5 12 5C11.6022 5 11.2207 5.15804 10.9394 5.43934Z",
    fill: "var(--icon-primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "var(--icon-primary-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.46fcb0900838997b968a27d4b10062b2.svg";
export { ForwardRef as ReactComponent };